/* @flow */
import * as React from 'react';
import AdminHeadline from 'admin/components/AdminHeadline';
import NumberWithLabel from 'components/NumberWithLabel';
import Text from 'components/Text';

type Props = {
  data: {
    parents: number,
    students: number,
    teachers: number,
  },
  duration: 'last month' | 'last week' | 'yesterday',
  teachers?: boolean,
};

const AdminStatisticsReachChartHeadline = (props: Props) => {
  const { data, duration, teachers } = props;

  if (teachers) {
    return (
      <AdminHeadline>
        <Text weight="bold">
          <NumberWithLabel label="teacher" value={data.teachers} />
        </Text>{' '}
        sent messages {duration}.
      </AdminHeadline>
    );
  } else {
    return (
      <AdminHeadline>
        <Text weight="bold">
          <NumberWithLabel label="student" value={data.students} />
        </Text>{' '}
        and{' '}
        <Text weight="bold">
          <NumberWithLabel label="parent" value={data.parents} />
        </Text>{' '}
        received messages on Remind {duration}.
      </AdminHeadline>
    );
  }
};

export default AdminStatisticsReachChartHeadline;
